import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Plus } from "lucide-react";
import { fmtBy } from "@/lib/format";
import { KPI_LABELS, DEAL_TYPES } from "@/lib/dealSpecs";

export default function DealsList() {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [dealType, setDealType] = useState("");
    const [status, setStatus] = useState("");

    const load = async () => {
        const p = new URLSearchParams();
        if (dealType) p.set("deal_type", dealType);
        if (status) p.set("status", status);
        const { data } = await api.get(`/deals?${p}`);
        setRows(data.items || []); setTotal(data.total || 0);
    };
    useEffect(() => { load(); /* eslint-disable-next-line */ }, [dealType, status]);

    return (
        <div className="p-6 md:p-10" data-testid="page-deals">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <div className="overline">Forge Vision</div>
                    <h1 className="mt-2 font-display text-4xl tracking-tight leading-none">Deals</h1>
                    <div className="text-sm text-muted-foreground mt-2">{total} total · Seven calculators, one deal score.</div>
                </div>
                <Link to="/app/deals/new" className="bg-foreground text-background px-4 py-2 text-sm inline-flex items-center gap-2 hover:opacity-90" data-testid="new-deal-btn"><Plus size={14} /> New deal</Link>
            </div>
            <div className="flex gap-3 mb-4">
                <select value={dealType} onChange={(e) => setDealType(e.target.value)} className="border border-border bg-background px-3 py-2 text-sm" data-testid="deals-filter-type">
                    <option value="">All types</option>
                    {DEAL_TYPES.map((d) => <option key={d.key} value={d.key}>{d.label}</option>)}
                </select>
                <select value={status} onChange={(e) => setStatus(e.target.value)} className="border border-border bg-background px-3 py-2 text-sm" data-testid="deals-filter-status">
                    <option value="">All statuses</option>
                    {["draft", "under_review", "approved", "rejected", "converted_to_project"].map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
            </div>
            {rows.length === 0 && (
                <div className="border border-border p-8 text-sm text-muted-foreground" data-testid="deals-empty">
                    No deals yet. <Link to="/app/deals/new" className="underline text-navy">Analyze your first deal</Link>.
                </div>
            )}
            <div className="grid md:grid-cols-2 gap-4">
                {rows.map((d) => {
                    const kpis = (KPI_LABELS[d.deal_type] || []).slice(0, 3);
                    return (
                        <Link key={d.id} to={`/app/deals/${d.id}`} className="border border-border p-6 hover:border-navy/60 transition-colors" data-testid={`deal-card-${d.id}`}>
                            <div className="flex items-center justify-between">
                                <div className="chip">{d.deal_type.replace(/_/g, " ")}</div>
                                <div className="text-xs text-muted-foreground capitalize">{d.status.replace(/_/g, " ")}</div>
                            </div>
                            <div className="mt-4 font-display text-2xl tracking-tight">{d.name}</div>
                            <div className="mt-6 grid grid-cols-3 gap-3">
                                {kpis.map((k) => (
                                    <div key={k.key}>
                                        <div className="overline">{k.label}</div>
                                        <div className="mt-1 text-sm font-medium">{fmtBy(k.fmt, d.results?.[k.key])}</div>
                                    </div>
                                ))}
                            </div>
                            {d.deal_score && (
                                <div className="mt-4 text-xs text-navy">Score {d.deal_score.score} · {d.deal_score.grade}</div>
                            )}
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
